import { useEffect, useState } from 'react';
import debounce from './debounce';

const MOBILE_WIDTH = 768;

const getWindowWidth = () => window.innerWidth ?? document.documentElement.clientWidth ?? document.body.clientWidth;

export const isMobileDevice = (providedWindowWidth?: number) =>
  (providedWindowWidth ?? getWindowWidth()) <= MOBILE_WIDTH;

const useIsMobileDevice = () => {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth());

  useEffect(() => {
    const onResize = debounce(() => {
      setWindowWidth(getWindowWidth());
    }, 1000);

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return isMobileDevice(windowWidth);
};

export default useIsMobileDevice;
